'use client';
import { NextPage } from 'next';
import React, { useState, useEffect } from 'react';
import Button from './Button';
import { shallow } from 'zustand/shallow';
import useOnboardingFormStore from '../../dashboard/stores/useOnboardingFormStore';
import { OnboardingFormComponentProps } from '../utils/types';
import { AnalyticsEvents, track } from '../../../src/utils/AnalyticsUtils';

const Welcome: NextPage<OnboardingFormComponentProps> = ({ currentStep, setCurrentStep, submitedForms, setSubmitedForms }) => {
    const [steps, setCurrentStepToStore] = useOnboardingFormStore((state) => [state.steps, state.setCurrentStepToStore], shallow);

    const handleButtonClick = () => {
        setSubmitedForms([...submitedForms, currentStep]);
        setCurrentStepToStore({ id: currentStep, data: {}, isSubmited: true });
        setCurrentStep(currentStep + 1);
        track(AnalyticsEvents.ONBOARDING_NEXT_PRESSED_WELCOME_SCREEN);
    };

    return (
        <div className="flex flex-col gap-4 w-3/4">
            <h1 className="text-kartiv-gray-900 text-2xl font-semibold">Transform your marketing with amazing visuals</h1>
            <p className="text-gray-600">
                We're excited to help you create stunning visuals that elevate your brand and boost your marketing efforts. Let's get
                started!
            </p>
            <div className="pt-4">
                <Button label="Next" onClick={handleButtonClick} isArrow />
            </div>
        </div>
    );
};

export default Welcome;